<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:body>
            <b-row>
                <b-col lg="12" sm="12">
                    <div style="font-size: 16px; background-color: rgb(51, 121, 130);"><h5 class="text-white text-center">{{$t('admission_management.admission_fee')}}</h5></div>
                    <b-table-simple striped bordered small hover class="mb-5">
                        <tbody>
                            <b-tr>
                                <b-th width="30%">{{$t('globalTrans.year')}}</b-th>
                                <b-td>{{ $n(admission.year, {useGrouping: false}) }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{$t('ds_institute_management.organization_name')}}</b-th>
                                <b-td>{{$i18n.locale === 'bn' ? admission.org_bn : admission.org}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{$t('ds_institute_management.institute_type')}}</b-th>
                                <b-td>{{$i18n.locale === 'bn' ? admission.office_type_bn : admission.office_type}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{$t('ds_institute_management.institute_name')}}</b-th>
                                <b-td>{{$i18n.locale === 'bn' ? admission.office_bn : admission.office}}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{ $t('globalTrans.name')}}</b-th>
                                <b-td>{{ $i18n.locale === 'bn' ? admission.admission.name_bn : admission.admission.name_en }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{ $t('globalTrans.mobile_no')}}</b-th>
                                <b-td>{{ admission.admission.mobile_no | mobileNumber }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{ $t('online_admission.class')}}</b-th>
                                <b-td>{{ getClassName(admission.admission.class_id) }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{ $t('ds_student_management.student_roll')}}</b-th>
                                <b-td>{{ admission.admission.student_id ? $n(admission.admission.student_id, { useGrouping: false }) : '' }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{ $t('admission_management.admission_fee')}}</b-th>
                                <b-td>{{ admission.fee_type === 2 ? $n(admission.admission_fee) : $t('admission_management.full_schoolership') }}</b-td>
                            </b-tr>
                            <b-tr v-if="admission.fee_type === 2">
                                <b-th>{{ $t('admission_management.monthly_fee')}}</b-th>
                                <b-td>{{ $n(admission.monthly_fee) }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th>{{ $t('admission_management.remarks')}}</b-th>
                                <b-td>{{admission.remarks}}</b-td>
                            </b-tr>
                        </tbody>
                    </b-table-simple>
                    <b-button variant="danger" class="float-right mr-1" @click="$bvModal.hide('modal-detail')">{{ $t('globalTrans.close') }}</b-button>
                </b-col>
            </b-row>
        </template>
    </iq-card>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'

export default {
    name: 'Details',
    props: ['id'],
    created () {
      if (this.id) {
          this.getData()
      }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            loading: false,
            admission: {
                id: '',
                fiscal_year_id: 0,
                org_id: 0,
                office_type_id: 0,
                office_id: 0,
                student_id: '',
                admission_fee: '',
                remarks: '',
                remarks_bn: ''
            }
        }
    },
    methods: {
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
            this.admission = tmpData
        },
        getClassName (Id) {
            const Obj = this.$store.state.DisabilitySchoolService.commonObj.classList.find(item => item.value === parseInt(Id))
            if (this.$i18n.locale === 'bn') {
                return Obj.text_bn
            } else {
                return Obj.text_en
            }
        }
    }
}
</script>
